"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function calculateDifference(data) {
  var diffValues = function diffValues(array1, array2) {
    var series = [];
    for (var j = 0; j < array1.length; j++) {
      var valueDifference = array1[j][1] - array2[j][1];
      series.push([array1[j][0], valueDifference]);
    }
    return series;
  };
  var difference = {
    name: [data[0].name, data[1].name],
    data: []
  };
  for (var i = 0; i < data[0].data.length; i++) {
    difference.data[i] = {
      seriesName: data[0].data[i].seriesName,
      seriesValues: diffValues(data[0].data[i].seriesValues, data[1].data[i].seriesValues)
    };
  }
  return difference;
}
var _default = calculateDifference;
exports["default"] = _default;